<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter" ref="CommonLayout">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            <a v-if="listType === 'projectList'" id="projectList" class="ml-1 list-type active-list" @click="changeListType('projectList')">制作案件一覧</a>
            <a v-else id="projectList" class="ml-1 list-type" @click="changeListType('projectList')">制作案件一覧</a>
            <a v-if="listType === 'dataList'" id="dataList" class="ml-1 list-type active-list" @click="changeListType('dataList')">発注データ作成</a>
            <a v-else id="dataList" class="ml-1 list-type" @click="changeListType('dataList')">発注データ作成</a>
            <a id="orderList" class="ml-1 list-type" @click="moveOrderList()">発注履歴</a>
            <a id="deliveryEvaluation" class="ml-1 list-type" :href="deliveryEvaluationURL" target="deliveryEvaluation">納品評価</a>
            <a v-show="isAllowedAccess" id="materialsAndEquipmentAdjustmentList" class="ml-1 list-type" :href="materialsAndEquipmentAdjustmentListURL" target="materialsAndEquipmentAdjustmentList">資器材回し用一覧</a>
          </div>
        </div>

        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-blue text-left text-black" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel" v-if="listType === 'projectList'">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group">
                      <label for="code" class="control-label col-sm-12">ステータス</label>
                      <div class="col-sm-12">
                        <template v-for="(searchStatusLabel, index) in searchStatusLabels">
                          <div class="form-check form-check-inline" :key="index + 'statusLabel'">
                            <input class="ml-3" type="checkbox" name="inlineRadioOptions" :id="searchStatusLabel['key']" :value="searchStatusLabel['value']" :checked="searchStatusLabel['value'] === '制作依頼完了' || searchStatusLabel['value'] === '案件セット印刷済'">
                            <label class="form-check-label" :for="searchStatusLabel['key']">{{searchStatusLabel['value']}}</label>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-7 row">
                        <div class="col-sm-4">
                          <label for="name" class="control-label col-sm-12">案件No.</label>
                          <div class="col-sm-12 pr-0">
                            <input type="text" id="project-number" class="form-control input-sm search-project-condition" v-model="searchProjectNumber"/>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <label for="name" class="control-label col-sm-12">施設名</label>
                          <div class="col-sm-12 pr-0">
                            <select id="facility-name" class="form-control input-sm search-project-condition" v-model="searchFacilityName">
                              <option value="">選択してください</option>
                              <option v-for="(facility, index) in getFacilities()" :key="index + 'fcility'" :value="facility['施設名']['value']">{{facility['施設名']['value']}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <label for="continent" class="control-label col-sm-12">ご両家名</label>
                          <div class="col-sm-12 pr-0">
                            <input type="text" id="both-family-name" class="form-control input-sm search-project-condition" v-model="searchBothFamilyName"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-5 row pr-0">
                        <div class="row">
                          <label for="continent" class="control-label col-sm-12">挙式日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" name="continent" id="wedding-date-from" class="form-control input-sm search-project-condition" v-model="searchWeddingDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" name="continent" id="wedding-date-to" class="form-control input-sm search-project-condition" v-model="searchWeddingDateTo"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>

                      <b-button class="main-color text-light w-25 ml-3" @click="searchProject()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
              <!-- 発注データ作成検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel" v-if="listType === 'dataList'">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="name" class="control-label col-sm-12">エリア</label>
                          <div class="col-sm-12 pr-0">
                            <select id="area-name" class="form-control input-sm search-condition" v-model="searchAreaName" :disabled="cookieIsAdmin !== '1'">
                              <option value="">選択してください</option>
                              <option v-for="(area, index) in getAreas()" :key="index + 'area'" :value="area['エリア名']['value']" :selected="searchAreaName === area['エリア名']['value']">{{area['エリア名']['value']}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="name" class="control-label col-sm-12">ユニット</label>
                          <div class="col-sm-12 pr-0">
                            <select id="unit-name" class="form-control input-sm search-condition" v-model="searchUnitName" :disabled="cookieIsAdmin !== '1'">
                              <option value="">選択してください</option>
                              <option v-for="(unit, index) in getUnits()" :key="index + 'unit'" :value="unit['ユニット名']['value']" :selected="searchUnitName === unit['ユニット名']['value']">{{unit['ユニット名']['value']}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="name" class="control-label col-sm-12">制作拠点</label>
                          <div class="col-sm-12 pr-0">
                            <select id="productionBase-code" class="form-control input-sm search-condition" v-model="searchProductionBaseCode" :disabled="cookieIsAdmin !== '1'">
                              <option value="">選択してください</option>
                              <option v-for="(productionBase, index) in getProductionBases()" :key="index + 'productionBase'" :value="productionBase['制作拠点コード']['value']" :selected="searchProductionBaseCode === productionBase['制作拠点コード']['value']">{{productionBase['制作拠点名']['value']}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="name" class="control-label col-sm-12">施設名</label>
                          <div class="col-sm-12 pr-0">
                            <select id="facility-name" class="form-control input-sm search-condition" v-model="searchFacilityName">
                              <option value="">すべて</option>
                              <option v-for="(facility, index) in getFacilities()" :key="index + 'fcility'" :value="facility['施設名']['value']" :selected="searchFacilityName === facility['施設名']['value']">{{facility['施設名']['value']}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="continent" class="control-label col-sm-12">発注状況</label>
                          <div class="col-sm-12 pr-0">
                            <select type="text" id="search-data-create" class="form-control input-sm search-condition" v-model="searchDataCreate">
                              <option value="0" :selected="searchDataCreate === '0'">未発注</option>
                              <option value="1" :selected="searchDataCreate === '1'">発注済</option>
                              <option value="" :selected="searchDataCreate === ''">すべて</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 row ml-1">
                        <div class="row">
                          <label for="continent" class="control-label col-sm-12">挙式日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" name="continent" id="wedding-date-from" class="form-control input-sm search-condition" v-model="searchWeddingDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" name="continent" id="wedding-date-to" class="form-control input-sm search-condition" v-model="searchWeddingDateTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12">
                          <label for="name" class="control-label col-sm-12">案件No.</label>
                          <div class="col-sm-12 pr-0">
                            <input type="text" id="project-number" class="form-control input-sm search-condition" v-model="searchProjectNumber"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>

                      <b-button class="main-color text-light w-25 ml-3" @click="searchProject()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 案件制作一覧リスト -->
        <div id="search-list" class="row base-color mt-3" v-if="listType === 'projectList'">
          <div class="col-sm-12 row pt-3 pr-0">
            <div class="col-sm-5">
              検索結果<span class="h3 ml-1">{{this.projectLength}}</span><span class="ml-1 mr-2">件</span>{{projectLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
            </div>
            <div class="col-sm-7 text-right pr-0">
              <b-button class="mr-4 main-color" @click="openMaterialsAndEquipmentModal()">
                <b-icon icon="file-earmark-excel" aria-hidden="true"></b-icon>&nbsp;資器材集計表
              </b-button>
              <b-button class="mr-4 main-color" @click="openMawashiModal('csv')">
                <b-icon icon="file-earmark-text" aria-hidden="true"></b-icon>&nbsp;回し表CSV
              </b-button>
              <b-button class="mr-4 main-color" @click="openMawashiModal('excel')">
                <b-icon icon="file-earmark-excel" aria-hidden="true"></b-icon>&nbsp;回し表
              </b-button>
              <b-button variant="primary" @click="postDeliveryDateTime">納品完了を登録</b-button>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <b-table-simple bordered class="small">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th rowspan="1" class="align-middle text-center" style="width: 13%;">案件No.</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 8%;">施行日</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 27%;">施設</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 27%;">ご両家名</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 13%;">披露宴時間</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 12%;">担当</th>
                </tr>
                <tr>
                  <th class="align-middle text-center">ステータス</th>
                  <th class="align-middle text-center">明細種別</th>
                  <th class="align-middle text-center">披露宴会場</th>
                  <th class="align-middle text-center">合計金額</th>
                </tr>
              </thead>
              <template v-for="(project, index) in activeProjectList">
                <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                  <b-tr :key="index + 'activeProject'">
                    <b-td v-if="getProjectStatus(project['案件ステータス']['value']) >= 4" class="align-middle">
                      <a :href="project['見積URL_プランナー']['value']" target="_blank">{{project['案件番号']['value'] ? project['案件番号']['value'] : '未定'}}</a>
                    </b-td>
                    <b-td v-else class="align-middle">
                      {{project['案件番号']['value'] ? project['案件番号']['value'] : '未定'}}
                    </b-td>
                    <b-td class="align-middle">{{project['施工日']['value'] ? formatDate(project['施工日']['value']) : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['施設名']['value'] ? project['施設名']['value'] : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['ご両家名_最新']['value'] ? project['ご両家名_最新']['value'] : ''}}</b-td>
                    <b-td class="align-middle">{{project['披露宴開始時刻']['value'] ? project['披露宴開始時刻']['value'] : '未定'}}〜{{project['披露宴終了時刻']['value'] ? project['披露宴終了時刻']['value'] : '未定'}}</b-td>
                    <!-- 担当者 -->
                    <b-td v-if="getProjectStatus(project['案件ステータス']['value']) >= 4" :rowspan="1" class="align-middle">{{project['担当者']['value'][0] ? project['担当者']['value'][0]['name'] : '未定'}}</b-td>
                    <b-td v-else></b-td>
                  </b-tr>
                  <b-tr :key="index">
                    <b-td :id="'projectNumber' + project['レコード番号']['value']" class="align-middle">{{convertStatusDisp(project['案件ステータス']['value'])}}</b-td>
                    <b-td class="align-middle">{{project['打合せ種別']['value'] ? project['打合せ種別']['value'] : ''}}</b-td>
                    <b-td :colspan="2" class="p-0 bb-none">
                      <div v-if="getProjectStatus(project['案件ステータス']['value']) >= 6">
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 1) ? ' white-btn' : ' main-color')" @click="getProductionSheetsPDF(project['レコード番号']['value'],'業務依頼書')">
                          業務依頼書
                        </b-button>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 2) ? ' white-btn' : ' main-color')" @click="getProductionSheetsPDF(project['レコード番号']['value'],'制作タグ')">
                          制作タグ
                        </b-button>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 3) ? ' white-btn' : ' main-color')" @click="getProductionSheetsPDF(project['レコード番号']['value'],'制作指示書')">
                          制作指示書
                        </b-button>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 4) ? ' white-btn' : ' main-color')" @click="getProductionImageSheets(project['レコード番号']['value'])">
                          制作画像
                        </b-button>
                        <br>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 5) ? ' white-btn' : ' main-color')" @click="materialsAndEquipmentSheetsEXCEL(project['レコード番号']['value'])">
                          資器材表
                        </b-button>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 6) ? ' white-btn' : ' main-color')" @click="getRecipeSheets(project['レコード番号']['value'])">
                          レシピ表
                        </b-button>
                        <b-button :class="'ml-1 mr-1 button-font-small button-adjustment' + (getButtonByFlags(project['レコード番号']['value'], 7) ? ' white-btn' : ' main-color')" @click="getDeliveredSheetsPDF(project['レコード番号']['value'])">
                          納品書
                        </b-button>
                        <!-- 納品完了 -->
                        <label class="ml-1 mr-1 delivery-complete-btn button-font-small carrot-color align-middle mt-2" v-bind:for="'checkbox' + project['レコード番号']['value']" :id="'label' + project['レコード番号']['value']"><input true-value="true" type="checkbox" class="ml-2 aligin-middle" v-bind:id="'checkbox' + project['レコード番号']['value']" @change="showInput(project['レコード番号']['value'])">&nbsp;納品完了</label>
                        <!-- 納品画像 -->
                        <b-button class="ml-1 carrot-color button-font-small" @click="deliveryImagePageMove(project['レコード番号']['value'])">&nbsp;納品画像</b-button>
                      </div>
                    </b-td>
                    <b-td class="align-middle">{{project['披露宴会場名']['value'] ? project['披露宴会場名']['value'] : '未定'}}</b-td>
                    <!-- 合計金額 -->
                    <b-td v-if="getProjectStatus(project['案件ステータス']['value']) >= 4" :rowspan="1" class="align-middle">{{project['合計金額']['value'] ? toComma(project['合計金額']['value']) + '円' : ''}}</b-td>
                    <b-td v-else></b-td>
                  </b-tr>
                  <b-tr :key="index + 'projectThirdRow'" class="hide" v-bind:id="'form' + project['レコード番号']['value']" v-if="getProjectStatus(project['案件ステータス']['value']) >= 6">
                    <b-td colspan="6" class="bt-none">
                      <div class="row mt-2">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8">
                          <span class="ml-2">納品完了日時</span>
                          <select class="ml-2" v-bind:id="'date' + project['レコード番号']['value']" @change="getDate(project['レコード番号']['value'])" v-if="!getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">
                            <option
                              v-for="date in getDeliverableDate(project['施工日']['value'])"
                              :value="date"
                              :key="date"
                              :selected="date === project['制作者納品完了日']['value']">
                              {{formatDate(date)}}
                            </option>
                          </select>
                          <span v-if="getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">{{formatDate(project['制作者納品完了日']['value'])}}</span>
                          <select :id="'hour' + project['レコード番号']['value']" :value="showHour(project['制作者納品完了時刻']['value'])" class="my-3" @change="getHour(project['レコード番号']['value'])" v-if="!getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">
                            <option
                              v-for="hour in getNumberArr({6: 22}, 1)"
                              :value="hour"
                              :key="hour" >
                              {{ hour }}
                            </option>
                          </select>
                          <span v-if="getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">{{showHour(project['制作者納品完了時刻']['value'])}}</span>
                          <span class="my-3">:</span>
                          <select :id="'minute' + project['レコード番号']['value']" :value="showMinute(project['制作者納品完了時刻']['value'])" class="my-3" @change="getMinute(project['レコード番号']['value'])" v-if="!getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">
                            <option
                              v-for="minute in getNumberArr({0: 55}, 5)"
                              :value="minute"
                              :key="minute" >
                              {{ minute }}
                            </option>
                          </select>
                          <span v-if="getNohinKanryo(project['案件ステータス']['value'], project['制作者納品完了日']['value'])">{{showMinute(project['制作者納品完了時刻']['value'])}}</span>
                        </div>
                      </div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
            </b-table-simple>
          </div>
          <div class="col-sm-12 row pt-3 pr-0">
            <div class="col-sm-4">
              検索結果<span class="h3 ml-1">{{this.projectLength}}</span><span class="ml-1 mr-2">件</span>{{projectLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
            </div>
            <div class="col-sm-4">
              <paginate
                v-model="page"
                :page-count="Math.ceil(projectLength / pageMaxNum)"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                >
              </paginate>
            </div>
            <div class="col-sm-4 text-right pr-0">
              <b-button variant="primary" @click="postDeliveryDateTime">納品完了を登録</b-button>
            </div>
          </div>
        </div>

        <!-- 発注データ作成リスト -->
        <div id="search-list" class="row base-color mt-3" v-if="listType === 'dataList'">
          <div class="col-sm-10 pt-4 text-right pr-0">
            <label class="form-check-label">分けて集計</label>
            <div class="form-check form-check-inline">
              <input class="ml-3" type="checkbox" name="inlineCheckBox" id="checkBoxBouquet" value="1" @change="getCheckBouquet()">
              <label class="form-check-label" @click="objChecked('checkBoxBouquet')">ブーケ</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="ml-3" type="checkbox" name="inlineCheckBox" id="checkBoxOutsideCommerce" value="1" @change="getCheckOutsideCommerce()">
              <label class="form-check-label" @click="objChecked('checkBoxOutsideCommerce')">外商</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="ml-3" type="checkbox" name="inlineCheckBox" id="checkBoxHotelOthers" value="1" @change="getCheckHotelOthers()">
              <label class="form-check-label" @click="objChecked('checkBoxHotelOthers')">ホテルその他</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="ml-3" type="checkbox" name="inlineCheckBox" id="checkBoxNotSalesOthers" value="1" @change="getCheckNotSalesOthers()">
              <label class="form-check-label" @click="objChecked('checkBoxNotSalesOthers')">売上外その他</label>
            </div>
          </div>
          <div class="col-sm-2 pt-3 pr-0">
            <div class="text-right pr-0">
              <b-button variant="primary" class="mr-4" @click="sortProjects">集計</b-button>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <b-table-simple hover bordered>
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th class="align-middle text-center" style="width: 5%;" @click="allCheck()">発注対象</th>
                  <th class="align-middle text-center" style="width: 7.4%;" @click="sortBy('案件番号')">案件No.</th>
                  <th class="align-middle text-center" style="width: 12%;" @click="sortBy('データ作成')">データ<br>作成</th>
                  <th class="align-middle text-center" style="width: 15%;" @click="sortBy('施設名')">施設</th>
                  <th class="align-middle text-center" style="width: 8.2%;" @click="sortBy('打合せ種別')">明細種別</th>
                  <th class="align-middle text-center" style="width: 8%;" @click="sortBy('売上大項目')">売上<br>大項目</th>
                  <th class="align-middle text-center" style="width: 11.6%;" @click="sortBy('施工日')">施行日</th>
                  <th class="align-middle text-center" style="width: 10%;" @click="sortBy('披露宴会場名')">会場</th>
                  <th class="align-middle text-center" style="width: 12.8%;" @click="sortBy('ご両家名_最新')">ご両家名</th>
                  <th class="align-middle text-center" style="width: 10%;" @click="sortBy('担当者')">担当</th>
                </tr>
              </thead>
              <b-tbody>
                <template v-for="(project, index) in activeProjectList">
                  <b-tr :key="index + 'activeProject'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                    <b-td class="align-middle text-center" style="padding-top: 0.25rem !important;"><input :id="'check' + index" type="checkbox" class="sort-check" :value="project['レコード番号']['value']"></b-td>
                    <b-td class="align-middle">{{project['案件番号']['value'] ? project['案件番号']['value'] : '未定'}}</b-td>
                    <b-td class="align-middle text-center">{{(project['データ作成'] && project['データ作成']['value']) ? project['データ作成']['value'] : ''}}</b-td>
                    <b-td class="align-middle">{{project['施設名']['value'] ? project['施設名']['value'] : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['打合せ種別']['value'] ? project['打合せ種別']['value'] : ''}}</b-td>
                    <b-td class="align-middle">{{project['売上大項目']['value'] ? project['売上大項目']['value'] : ''}}</b-td>
                    <b-td class="align-middle">{{project['施工日']['value'] ? formatDate(project['施工日']['value']) : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['披露宴会場名']['value'] ? project['披露宴会場名']['value'] : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['ご両家名_最新']['value'] ? project['ご両家名_最新']['value'] : '未定'}}</b-td>
                    <b-td class="align-middle">{{project['担当者']['value'][0] ? project['担当者']['value'][0]['name'] : '未定'}}</b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </div>
          <div class="col-sm-12 pt-3 pr-0">
            <div class="text-right pr-0">
              <b-button variant="primary" class="mr-4" @click="sortProjects">集計</b-button>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
    <MawashiModal ref="mawashiModal" />
    <MaterialsAndEquipmentModal ref="materialsAndEquipmentModal" />
    <CommonModal ref="commonModal" @confirmOk="logout" />
  </CommonLayout>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import CommonLayout from '@/layout/CommonLayout'
import MawashiModal from '@/components/MawashiModal'
import MaterialsAndEquipmentModal from '@/components/MaterialsAndEquipmentModal'
import ProjectListModel from '@/models/ProjectListModel'
import AreaListModel from '@/models/AreaListModel'
import UnitListModel from '@/models/UnitListModel'
import ProductionBaseListModel from '@/models/ProductionBaseListModel'
import FacilityListModel from '@/models/FacilityListModel'
import DeliveredProjectCompleteModel from '@/models/DeliveredProjectCompleteModel'
import ProductionSheetsModel from '@/models/ProductionSheetsModel'
import ProductionInstructionImageSheetsModel from '@/models/ProductionInstructionImageSheetsModel'
import DeliveredSheetsModel from '@/models/DeliveredSheetsModel'
import SearchProjectModel from '@/models/SearchProjectModel'
import CookieDataModel from '@/models/CookieDataModel'
import MaterialsAndEquipmentSheetsModel from '@/models/MaterialsAndEquipmentSheetsModel'
import RecipeSheetsModel from '@/models/RecipeSheetsModel'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

export default {
  name: 'ProjectList',
  components: {
    CommonLayout,
    MawashiModal,
    MaterialsAndEquipmentModal,
    ProductionSheetsModel,
    DeliveredSheetsModel,
    ProductionInstructionImageSheetsModel,
    MaterialsAndEquipmentSheetsModel,
    RecipeSheetsModel,
    CommonModal
  },
  data () {
    return {
      overlayShow: false,
      projectData: [],
      activeProjectList: [],
      projectLength: 0,
      areaData: [],
      unitData: [],
      productionBaseData: [],
      facilityData: [],
      page: 1,
      pageMaxNum: 10,
      pageStart: 0,
      pageEnd: 0,
      searchStatusLabels: [
        {'key': 'blank', 'value': '打合せ未完了'},
        {'key': 'meeting-complete', 'value': '打合せ完了'},
        {'key': 'request-complete', 'value': '制作依頼完了'},
        {'key': 'set-printed', 'value': '案件セット印刷済'},
        {'key': 'delivery-complete', 'value': '納品完了・売上日報完了'}
      ],
      listType: this.$route.query.list_type || 'projectList',
      allChecked: false,
      searchDataCreate: '0',
      searchProjectNumber: '',
      searchAreaName: '',
      searchUnitName: '',
      searchProductionBaseCode: '',
      searchFacilityName: '',
      searchWeddingDateFrom: '',
      searchWeddingDateTo: '',
      searchBothFamilyName: '',
      projectNumberSortDirection: 'asc',
      dataCreateSortDirection: 'asc',
      facilitySortDirection: 'asc',
      meetingStyleSortDirection: 'asc',
      weddingDateSortDirection: 'asc',
      staffSortDirection: 'asc',
      receptionHallSortDirection: 'asc',
      bothFamilyNameSortDirection: 'asc',
      majorSalesCategorySortDirection: 'asc',
      cookieIsAdmin: 0,
      cookieProdBaseCode: '',
      materialsAndEquipmentAdjustmentListURL: '',
      deliveryEvaluationURL: '',
      allowProdBaseList: ['03850', '303032', '3140', '8132', '107010', '20170', '05970', '06111', '6110', '6500', '02710', '10260', '107009', '15392', '15490', '1528001321', '107013', '15290', '878716'],
      isAllowedAccess: false
    }
  },
  methods: {
    seartchClick () {
      this.overlayShow = true
      setTimeout(() => {
        this.overlayShow = false
      }, 4000)
    },
    deliveryImagePageMove (projectNumber) {
      this.$router.push('/delivered_image/' + projectNumber)
    },
    getProjects: function () {
      let list = this.projectData['projects']['records']
      return list
    },
    setProjects: async function (listType) {
      if (listType === 'projectList') {
        this.overlayShow = true
        const reqData = {'projectNumber': this.projectNumber, 'listType': listType}
        let projectData = await ProjectListModel.getApi(this.$bvModal, reqData, () => {})
        if (listType === this.listType) {
          this.projectData = projectData
        } else {
          // 検索中にリストタイプが切り替わったらsetProjectsを再実行する。
          this.setProjects(this.listType)
          return
        }
        this.projectLength = this.projectData['projects']['records'].length
        this.activeProjectList = []
        await this.setActiveProjectList()
        localStorage.removeItem('searchConditions')
        this.overlayShow = false
      } else if (listType === 'dataList') {
        this.overlayShow = true
        this.activeProjectList = []
        this.resetProjects()
        this.clearConditions()
        this.page = 1
        this.overlayShow = false
      }
    },
    formatDate (date) {
      // 日付のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW)'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      return format
    },
    getDeliverableDate (date) {
      // 施工日とその前日の配列を取得
      const newDate = new Date(date)
      const yesterday = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() - 1)
      let format = 'YYYY-MM-DD'
      format = format.replace(/YYYY/, yesterday.getFullYear())
      format = format.replace(/MM/, yesterday.getMonth() + 1 >= 10 ? yesterday.getMonth() + 1 : '0' + (yesterday.getMonth() + 1))
      format = format.replace(/DD/, yesterday.getDate() >= 10 ? yesterday.getDate() : '0' + yesterday.getDate())
      const deliverableDate = {
        format,
        date
      }
      return deliverableDate
    },
    showHour (time) {
      if (time != null) {
        const times = time.split(':')
        return times[0]
      }
    },
    showMinute (time) {
      if (time != null) {
        const times = time.split(':')
        return times[1]
      }
    },
    toComma (num) {
      if ((num).trim().length !== 0 && !isNaN(num)) {
        let newNum = Number(num).toLocaleString()
        return newNum
      }
    },
    getProjectStatus (data) {
      const status = {
        '施設成約済': 1,
        '打合せ日程確定': 2,
        '打合せ中': 3,
        '打合せ完了': 4,
        'レシピ編集済み': 4,
        'レシピ組み完了': 5,
        '制作依頼完了': 6,
        '案件セット印刷済': 7,
        '納品完了': 8,
        '売上日報完了': 9,
        '発注集計完了': 15,
        '変更依頼': 20,
        'キャンセル': 30,
        '他社成約済': 99
      }
      return (data in status) ? status[data] : 0
    },
    getNohinKanryo (status, nohindate) {
      return (this.getProjectStatus(status) >= 8 && nohindate > '1970-01-01')
    },
    convertStatusDisp (status) {
      return (['打合せ日程確定', '打合せ中'].indexOf(status) > -1 && '-') || (['レシピ組み完了', 'レシピ編集済み'].indexOf(status) > -1 && '打合せ完了') || status
    },
    getButtonByFlags: function (projectNumber, btnNum) {
      const flags = this.projectData['flags'][projectNumber]
      if (typeof flags !== 'undefined') {
        switch (btnNum) {
          case 1:
            return ('projectSetPrinted' in flags && flags['projectSetPrinted'] === 1)
          case 2:
            return ('productionTagPrinted' in flags && flags['productionTagPrinted'] === 1)
          case 3:
            return ('productionInstructionsPrinted' in flags && flags['productionInstructionsPrinted'] === 1)
          case 4:
            return ('productionImagePrinted' in flags && flags['productionImagePrinted'] === 1)
          case 5:
            return ('materialsAndEquipmentSheetsPrinted' in flags && flags['materialsAndEquipmentSheetsPrinted'] === 1)
          case 6:
            return ('recipePrinted' in flags && flags['recipePrinted'] === 1)
          case 7:
            return ('deliverySetPrinted' in flags && flags['deliverySetPrinted'] === 1)
          default:
            return false
        }
      }
      return false // 未出力
    },
    getWasAggregated: function (projectNumber) {
      const flags = this.projectData['flags'][projectNumber]
      console.log(flags)
      if (typeof flags !== 'undefined') {
        if (flags['wasAggregated']) {
          return flags['wasAggregated']
        }
      }
      return ''
    },
    showInput (id) {
      document.getElementById('form' + id).classList.toggle('hide')
      console.log(document.getElementById('projectNumber' + id).rowSpan)
      if (document.getElementById('projectNumber' + id).rowSpan === 1) {
        document.getElementById('projectNumber' + id).rowSpan = 2
      } else {
        document.getElementById('projectNumber' + id).rowSpan = 1
      }
      console.log(document.getElementById('projectNumber' + id).rowSpan)
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    postDeliveryDateTime: async function () {
      try {
        const projectList = this.activeProjectList
        let params = []
        let length = projectList.length
        let checkedLength = 0
        for (let i = 0; i < length; i++) {
          if (this.getProjectStatus(projectList[i]['案件ステータス']['value']) > 5) {
            let completeList = {}
            const projectNumber = projectList[i]['レコード番号']['value']
            const checkbox = document.getElementById('checkbox' + projectNumber)
            if (checkbox !== null) { // 表示されていないチェックボックスはスキップ
              if (checkbox.checked) {
                const date = this.getDate(projectNumber)
                const hour = this.getHour(projectNumber)
                const minute = this.getMinute(projectNumber)
                const time = hour + ':' + minute
                if (date === false || hour === false || minute === false) {
                  this.$bvModal.msgBoxOk('納品完了済みのものが選択されています。')
                  return false
                }
                if (date === '' || hour === '' || minute === '') {
                  this.$bvModal.msgBoxOk('納品完了日時を入力してください。')
                  return false
                }
                if (this.compareDate(date)) {
                  this.$bvModal.msgBoxOk('納品日に未来の日付は入力できません。')
                  return false
                }
                completeList = {
                  'projectNumber': projectNumber,
                  'status': projectList[i]['案件ステータス']['value'],
                  'deliveredCompleteDate': date,
                  'deliveredCompleteTime': time
                }
                params.push(completeList)
                checkedLength += 1
              }
            }
          }
        }
        if (checkedLength === 0) {
          this.$bvModal.msgBoxOk('納品完了が選択されていません。')
          return false
        }
        this.overlayShow = true
        const result = await DeliveredProjectCompleteModel.postApi(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        setTimeout(() => {
          this.searchProject()
          if (result.status === 'success') {
            this.$bvModal.msgBoxOk('納品完了を登録しました。')
          }
        }, 1000)
      } catch (error) {
        console.error(error)
      }
    },
    getDate (id) {
      if (document.getElementById('date' + id) === null) {
        return false
      }
      return document.getElementById('date' + id).value
    },
    getHour (id) {
      if (document.getElementById('hour' + id) === null) {
        return false
      }
      return document.getElementById('hour' + id).value
    },
    getMinute (id) {
      if (document.getElementById('minute' + id) === null) {
        return false
      }
      return document.getElementById('minute' + id).value
    },
    getProductionSheetsPDF: async function (projectNumber, fileType) {
      this.overlayShow = true
      const reqData = {
        'projectNumber': projectNumber,
        'fileType': fileType
      }
      const result = await ProductionSheetsModel.postApi(this.$bvModal, reqData, () => {
      })
      if (result.status === 'success') {
        const url = result.items.filePath
        window.open(url, '_blank')
        this.searchProject(this.page)
      }
    },
    getProductionImageSheets: async function (projectNumber) {
      this.overlayShow = true
      const reqData = {
        'projectNumber': projectNumber
      }
      const prodImageResult = await ProductionInstructionImageSheetsModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      if (prodImageResult.status === 'success') {
        const prodImageUrl = prodImageResult.items.filePath
        window.open(prodImageUrl, '_blank')
        this.searchProject(this.page)
      }
    },
    getDeliveredSheetsPDF: async function (projectNumber) {
      this.overlayShow = true
      const reqData = {
        'projectNumber': projectNumber
      }
      const result = await DeliveredSheetsModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      const url = result.items.filePath
      window.open(url, '_blank')

      this.searchProject(this.page)
    },
    materialsAndEquipmentSheetsEXCEL: async function (projectNumber) {
      this.overlayShow = true
      const reqData = {
        'projectNumber': projectNumber
      }
      const result = await MaterialsAndEquipmentSheetsModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      const url = result.items.filePath
      window.open(url, '_blank')

      this.searchProject(this.page)
    },
    getRecipeSheets: async function (projectNumber) {
      this.overlayShow = true
      const reqData = {
        'projectNumber': projectNumber
      }
      const result = await RecipeSheetsModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      const url = result.items.filePath
      window.open(url, '_blank')

      this.searchProject(this.page)
    },
    searchProject: async function (nowpage = 1, isPageBack = false) {
      // チェック状態初期化
      await this.allUnCheck()
      // 検索時のリストタイプ取得
      let searchListType = this.listType

      if (searchListType === 'dataList' && !isPageBack) {
        if (!this.validate()) {
          return false
        }
        // dataListは1ページ固定
        nowpage = 1
      }
      this.page = nowpage
      this.overlayShow = true
      let params = {'listType': searchListType}
      if (searchListType === 'projectList') {
        const length = this.searchStatusLabels.length
        for (let i = 0; i < length; i++) { // ステータスチェックボックスの数だけ実行
          const status = this.searchStatusLabels[i]
          if (document.getElementById(status['key']).checked) {
            params[status['key']] = status['value']
          }
        }
      }
      if (this.searchProjectNumber !== '') {
        params['project-number'] = this.searchProjectNumber
      }
      if (this.searchFacilityName !== '') {
        params['facility-name'] = this.searchFacilityName
      }
      if (this.searchWeddingDateFrom !== '') {
        params['wedding-date-from'] = this.searchWeddingDateFrom
      }
      if (this.searchWeddingDateTo !== '') {
        params['wedding-date-to'] = this.searchWeddingDateTo
      }
      if (this.searchBothFamilyName !== '') {
        params['both-family-name'] = this.searchBothFamilyName
      }
      if (searchListType === 'dataList') {
        if (this.searchAreaName !== '') {
          params['area-name'] = this.searchAreaName
        }
        if (this.searchUnitName !== '') {
          params['unit-name'] = this.searchUnitName
        }
        if (this.searchProductionBaseCode !== '') {
          params['productionBase-code'] = this.searchProductionBaseCode
        }
        if (this.searchDataCreate !== '') {
          params['search-data-create'] = this.searchDataCreate
        }
      }
      let projectData = await SearchProjectModel.getApi(this.$bvModal, params, () => {
        this.overlayShow = false
      })

      if (searchListType !== this.listType) {
        // 検索中に画面が切り替わった場合は検索中断
        this.overlayShow = false
        return
      }

      this.projectData = projectData

      // 検索条件を保存
      let searchConditions = {}
      if (searchListType === 'projectList') {
        this.projectLength = projectData['projects']['records'].length
        await this.setActiveProjectList()

        // ステータスの検索条件を保存
        const length = this.searchStatusLabels.length
        for (let i = 0; i < length; i++) { // ステータスチェックボックスの数だけ実行
          const status = this.searchStatusLabels[i]
          if (document.getElementById(status['key']).checked) {
            searchConditions[status['key']] = true
          } else {
            searchConditions[status['key']] = false
          }
        }
        // 画面項目の検索条件を保存
        const searchInputs = document.getElementsByClassName('search-project-condition')
        for (const searchInput of searchInputs) {
          searchConditions[searchInput.id] = searchInput.value
        }
      } else if (searchListType === 'dataList') {
        // 発注データ作成の場合はページングがないためそのまま中身をセット
        this.activeProjectList = this.projectData['projects']['records']
        if (this.activeProjectList.length < 1) {
          setTimeout(() => {
            this.$bvModal.msgBoxOk(this.consts.applicationMsg.noResults)
          }, 0)
        }
        for (const project of this.activeProjectList) {
          project['データ作成'] = {'value': this.getWasAggregated(project['レコード番号']['value'])}
        }

        const searchInputs = document.getElementsByClassName('search-condition')
        for (const searchInput of searchInputs) {
          searchConditions[searchInput.id] = searchInput.value
        }
      }
      searchConditions['listType'] = searchListType
      localStorage.setItem('searchConditions', JSON.stringify(searchConditions))
    },
    setAreas: async function () {
      this.overlayShow = true
      const reqData = { 'projectNumber': this.projectNumber }
      this.areaData = await AreaListModel.getApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
    },
    getAreas () {
      if (!this.areaData['areas']) {
        return []
      }
      return this.areaData['areas']['records']
    },
    setUnits: async function () {
      this.overlayShow = true
      const reqData = { 'projectNumber': this.projectNumber, 'areaName': this.searchAreaName }
      this.unitData = await UnitListModel.getApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
    },
    getUnits () {
      if (!this.unitData['units']) {
        return []
      }
      return this.unitData['units']['records']
    },
    setProductionBases: async function () {
      this.overlayShow = true
      const reqData = { 'projectNumber': this.projectNumber, 'areaName': this.searchAreaName, 'unitName': this.searchUnitName }
      this.productionBaseData = await ProductionBaseListModel.getApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
    },
    getProductionBases () {
      if (!this.productionBaseData['productionBases']) {
        return []
      }
      return this.productionBaseData['productionBases']['records']
    },
    setFacilities: async function () {
      if (this.listType === 'projectList') {
        let searchPBC = ''
        if (this.cookieIsAdmin !== '1') {
          searchPBC = this.cookieProdBaseCode
        }
        this.overlayShow = true
        const reqData = { 'projectNumber': this.projectNumber, 'productionBaseCode': searchPBC }
        this.facilityData = await FacilityListModel.getApi(this.$bvModal, reqData, () => {
          this.overlayShow = false
        })
      } else if (this.listType === 'dataList') {
        if (this.searchProductionBaseCode || !this.cookieProdBaseCode) {
          this.overlayShow = true
          const reqData = { 'projectNumber': this.projectNumber, 'productionBaseCode': this.searchProductionBaseCode }
          this.facilityData = await FacilityListModel.getApi(this.$bvModal, reqData, () => {
            this.overlayShow = false
          })
        } else {
          this.facilityData['facilities'] = {}
        }
      }
    },
    getFacilities () {
      if (!this.facilityData['facilities']) {
        return []
      }
      return this.facilityData['facilities']['records']
    },
    clickCallback (pageNum) {
      this.page = pageNum // pageNumはpagerの何番目をclickしたかを取得
      this.setActiveProjectList()
    },
    setActiveProjectList: async function () {
      // チェック状態初期化
      await this.allUnCheck()

      this.pageStart = (this.page - 1) * this.pageMaxNum
      // pageが大きすぎる場合は表示可能になるまで減らす
      for (;this.page > 0;) {
        if (this.projectLength < this.pageStart) {
          this.page -= 1
          this.pageStart = (this.page - 1) * this.pageMaxNum
        } else {
          break
        }
      }

      this.pageEnd = this.pageStart + this.pageMaxNum
      if (this.projectLength < this.pageEnd) {
        this.pageEnd = this.pageStart + (this.projectLength % this.pageMaxNum)
      }
      this.activeProjectList = this.projectData['projects']['records'].slice(this.pageStart, this.pageEnd)

      localStorage.setItem('nowProjectListPage', this.page)
    },
    compareDate (date) {
      let dateList = date.split('-')
      let year = dateList[0]
      let month = dateList[1]
      let day = dateList[2]

      const newDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0)
      const today = new Date().setHours(0, 0, 0, 0)
      console.log(newDate)
      console.log(today)
      return newDate > today
    },
    changeListType: async function (type) {
      // 押した要素がアクティブでないことを確認
      if (this.listType !== type) {
        const elements = document.getElementsByClassName('list-type')
        for (const element of Object.values(elements)) {
          // 現在アクティブな要素のクラスを取り除く
          if (element.classList.contains('active-list') === true) {
            element.classList.toggle('active-list')
          }
        }

        // 検索条件初期化
        if (!JSON.parse(localStorage.getItem('isPageBack'))) {
          this.clearConditions()
          this.page = 1
        }

        // 対象の要素をアクティブにする
        document.getElementById(type).classList.toggle('active-list')
        this.listType = type
        await this.setProjects(type)
      }
    },
    moveOrderList () {
      this.$router.push('/order_list')
    },
    resetProjects () {
      this.projectData = []
      this.projectLength = 0
      this.pageStart = 0
      this.pageEnd = 0
    },
    logout () {
      // ログアウトさせる
      this.$refs.CommonLayout.logout()
    },
    sortProjects: async function () {
      // キャッシュに格納されている制作拠点コードと画面上の制作拠点コードが一致しているかチェック
      let latestCookieData = await CookieDataModel.getApi(this.$bvModal, () => {})
      let latestCookieProdBaseCode = latestCookieData['cookieData']['custom:ProdBaseCode']
      if (this.cookieProdBaseCode !== latestCookieProdBaseCode) {
        this.$refs.commonModal.confirmBoxOkCancel(latestCookieProdBaseCode + 'でログインされています。一度ログアウトし、再度ログインしてから発注を行う必要があります。ログアウトしますか？')
        return false
      }

      const inputs = document.getElementsByClassName('sort-check')
      let params = ''
      let checkedLength = 0
      for (const input of inputs) {
        if (input.checked) {
          if (params === '') {
            params += input.value
          } else {
            params += ',' + input.value
          }
          checkedLength++
        }
      }
      if (checkedLength === 0) {
        this.$bvModal.msgBoxOk('案件が選択されていません。')
        return false
      }
      const targetPath = '/aggregate_projects?projectNumber=' + params
      this.$router.push(targetPath)
    },
    allCheck () {
      if (this.allChecked === true) {
        for (let i = 0; i < this.activeProjectList.length; i++) {
          document.getElementById('check' + i).checked = false
        }
        this.allChecked = false
      } else {
        for (let i = 0; i < this.activeProjectList.length; i++) {
          document.getElementById('check' + i).checked = true
        }
        this.allChecked = true
      }
    },
    allUnCheck () {
      if (this.listType === 'projectList') {
        for (let i = 0; i < this.activeProjectList.length; i++) {
          let id = this.activeProjectList[i]['レコード番号']['value']
          if (document.getElementById('checkbox' + id) !== null) {
            document.getElementById('checkbox' + id).checked = false
          }
          if (document.getElementById('form' + id) !== null) {
            document.getElementById('form' + id).classList.add('hide')
          }
        }
      } else if (this.listType === 'dataList') {
        for (let i = 0; i < this.activeProjectList.length; i++) {
          document.getElementById('check' + i).checked = false
        }
        this.allChecked = false
      }
    },
    validate () {
      console.log(this.searchProductionBaseCode)
      console.log(this.searchWeddingDateFrom)
      console.log(this.searchWeddingDateTo)
      if (this.searchProductionBaseCode === '' && (this.cookieIsAdmin === '1' || this.cookieProdBaseCode)) {
        this.$bvModal.msgBoxOk('制作拠点は必須です。')
        return false
      }
      if (this.searchWeddingDateFrom === '' || this.searchWeddingDateTo === '') {
        this.$bvModal.msgBoxOk('挙式日は必須です。')
        return false
      }
      const from = new Date(this.searchWeddingDateFrom)
      const to = new Date(this.searchWeddingDateTo)
      let diffMilliSec = to - from
      if (parseInt(diffMilliSec / 1000 / 60 / 60 / 24) > 30) {
        this.$bvModal.msgBoxOk('挙式日の検索範囲は30日以内です。')
        return false
      }
      return true
    },
    clearConditions () {
      if (this.listType === 'projectList') {
        const length = this.searchStatusLabels.length
        for (let i = 0; i < length; i++) { // ステータスチェックボックスの数だけ実行
          const status = this.searchStatusLabels[i]
          if (status['value'] === '制作依頼完了' || status['value'] === '案件セット印刷済') {
            document.getElementById(status['key']).checked = true
          } else {
            document.getElementById(status['key']).checked = false
          }
        }
        this.searchProjectNumber = ''
        this.searchFacilityName = ''
        this.searchWeddingDateFrom = ''
        this.searchWeddingDateTo = ''
        this.searchBothFamilyName = ''
      } else if (this.listType === 'dataList') {
        this.searchDataCreate = '0'
        this.searchProjectNumber = ''
        this.searchAreaName = ''
        this.searchUnitName = ''
        this.searchProductionBaseCode = this.cookieProdBaseCode
        this.searchFacilityName = ''
        this.searchWeddingDateFrom = ''
        this.searchWeddingDateTo = ''
        this.searchBothFamilyName = ''
      }
    },
    pageBackDataSetUp () {
      const searchConditions = JSON.parse(localStorage.getItem('searchConditions'))
      console.log(searchConditions)
      if (searchConditions) {
        for (const [key, value] of Object.entries(searchConditions)) {
          if (key === 'search-data-create') {
            this.searchDataCreate = value
          } else if (key === 'project-number') {
            this.searchProjectNumber = value.trim()
          } else if (key === 'area-name') {
            this.searchAreaName = value
          } else if (key === 'unit-name') {
            this.searchUnitName = value
          } else if (key === 'productionBase-code') {
            this.searchProductionBaseCode = value
          } else if (key === 'facility-name') {
            this.searchFacilityName = value
          } else if (key === 'wedding-date-from') {
            this.searchWeddingDateFrom = value
          } else if (key === 'wedding-date-to') {
            this.searchWeddingDateTo = value
          } else if (key === 'both-family-name') {
            this.searchBothFamilyName = value
          }
        }
      }
    },
    pageBackSetUp () {
      const searchConditions = JSON.parse(localStorage.getItem('searchConditions'))
      let listType = ''
      if (searchConditions) {
        listType = searchConditions['listType']
      }

      this.page = parseInt(localStorage.getItem('nowProjectListPage'), 10)
      if (listType === 'projectList') {
        for (let i = 0; i < this.searchStatusLabels.length; i++) { // ステータスチェックボックスの数だけ実行
          const statusKey = this.searchStatusLabels[i]['key']
          if (searchConditions[statusKey]) {
            document.getElementById(statusKey).checked = true
          } else {
            document.getElementById(statusKey).checked = false
          }
        }
        this.searchProject(this.page, true)
      } else if (listType === 'dataList') {
        document.getElementById('dataList').click()
        this.searchProject(1, true)
      } else {
        this.listType = 'projectList'
        this.clearConditions()
        this.searchProject(this.page, true)
      }
      localStorage.removeItem('isPageBack')
    },
    sortBy (key) {
      this.overlayShow = true
      let projectList = this.activeProjectList
      this.activeProjectList = []
      setTimeout(() => {
        if (this.getSortDirection(key) === 'asc') {
          projectList = projectList.sort(function (a, b) {
            return (a[key]['value'] < b[key]['value']) ? -1 : 1 // 昇順ソート
          })
        } else {
          projectList = projectList.sort(function (a, b) {
            return (a[key]['value'] > b[key]['value']) ? -1 : 1 // 降順ソート
          })
        }
      }, 100)
      this.activeProjectList = projectList
      this.overlayShow = false
    },
    getSortDirection (key) {
      if (key === '案件番号') {
        if (this.projectNumberSortDirection === 'asc') {
          this.projectNumberSortDirection = 'desc'
          return 'asc'
        } else {
          this.projectNumberSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === 'データ作成') {
        if (this.dataCreateSortDirection === 'asc') {
          this.dataCreateSortDirection = 'desc'
          return 'asc'
        } else {
          this.dataCreateSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '施設名') {
        if (this.facilitySortDirection === 'asc') {
          this.facilitySortDirection = 'desc'
          return 'asc'
        } else {
          this.facilitySortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '打合せ種別') {
        if (this.meetingStyleSortDirection === 'asc') {
          this.meetingStyleSortDirection = 'desc'
          return 'asc'
        } else {
          this.meetingStyleSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '施工日') {
        if (this.weddingDateSortDirection === 'asc') {
          this.weddingDateSortDirection = 'desc'
          return 'asc'
        } else {
          this.weddingDateSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '担当者') {
        if (this.staffSortDirection === 'asc') {
          this.staffSortDirection = 'desc'
          return 'asc'
        } else {
          this.staffSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '披露宴会場名') {
        if (this.receptionHallSortDirection === 'asc') {
          this.receptionHallSortDirection = 'desc'
          return 'asc'
        } else {
          this.receptionHallSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === 'ご両家名_最新') {
        if (this.bothFamilyNameSortDirection === 'asc') {
          this.bothFamilyNameSortDirection = 'desc'
          return 'asc'
        } else {
          this.bothFamilyNameSortDirection = 'asc'
          return 'desc'
        }
      }
      if (key === '売上大項目') {
        if (this.majorSalesCategorySortDirection === 'asc') {
          this.majorSalesCategorySortDirection = 'desc'
          return 'asc'
        } else {
          this.majorSalesCategorySortDirection = 'asc'
          return 'desc'
        }
      }
    },
    openMawashiModal (type) {
      this.$refs.mawashiModal.showModal(type)
    },
    openMaterialsAndEquipmentModal () {
      this.$refs.materialsAndEquipmentModal.showModal()
    },
    getCheckBouquet () {
      const checkbox = document.getElementById('checkBoxBouquet')
      if (checkbox !== null && checkbox.checked) {
        localStorage.setItem('checkBouquet', '1')
      } else {
        localStorage.setItem('checkBouquet', '0')
      }
    },
    getCheckOutsideCommerce () {
      const checkbox = document.getElementById('checkBoxOutsideCommerce')
      if (checkbox !== null && checkbox.checked) {
        localStorage.setItem('checkOutsideCommerce', '1')
      } else {
        localStorage.setItem('checkOutsideCommerce', '0')
      }
    },
    getCheckHotelOthers () {
      const checkbox = document.getElementById('checkBoxHotelOthers')
      if (checkbox !== null && checkbox.checked) {
        localStorage.setItem('checkHotelOthers', '1')
      } else {
        localStorage.setItem('checkHotelOthers', '0')
      }
    },
    getCheckNotSalesOthers () {
      const checkbox = document.getElementById('checkBoxNotSalesOthers')
      if (checkbox !== null && checkbox.checked) {
        localStorage.setItem('checkNotSalesOthers', '1')
      } else {
        localStorage.setItem('checkNotSalesOthers', '0')
      }
    },
    setCookieData: async function () {
      this.CookieData = await CookieDataModel.getApi(this.$bvModal, () => {})
      if (this.CookieData) {
        if (this.CookieData['cookieData']['custom:IsAdmin']) {
          this.cookieIsAdmin = this.CookieData['cookieData']['custom:IsAdmin']
        }
        if (this.CookieData['cookieData']['custom:ProdBaseCode']) {
          this.cookieProdBaseCode = this.CookieData['cookieData']['custom:ProdBaseCode']
        }
        if (!this.searchProductionBaseCode) {
          this.searchProductionBaseCode = this.cookieProdBaseCode
        }
      }
    },
    setMaterialsAndEquipmentAdjustmentListURL: async function () {
      await this.setCookieData()
      this.materialsAndEquipmentAdjustmentListURL = this.config.materialsAndEquipmentAdjustmentListURL
      if (this.cookieProdBaseCode) {
        if (this.allowProdBaseList.includes(this.cookieProdBaseCode)) {
          let prodBaseCodeParam = '?prodBaseCode=' + this.cookieProdBaseCode
          this.materialsAndEquipmentAdjustmentListURL += prodBaseCodeParam
          this.isAllowedAccess = true
        }
      }
    },
    setDeliveryEvaluationURL () {
      this.deliveryEvaluationURL = this.config.deliveryEvaluationURL
      if (this.cookieProdBaseCode) {
        let prodBaseCodeParam = '?prodBaseCode=' + this.cookieProdBaseCode
        this.deliveryEvaluationURL += prodBaseCodeParam
      }
    },
    objChecked (id) {
      let idObj = document.getElementById(id)
      if (idObj !== null) {
        idObj.click()
      }
    }
  },
  computed: {
    getNumberArr: function () {
      return function (range, step) {
        const start = Object.keys(range)[0]
        const end = range[start]
        const arrCount = ((end - start) / step) + 1
        let array = [...Array(arrCount)].map((_, i) => Number(i * step) + Number(start))
        if (array[0] === 0) {
          array[0] = '00'
          array[1] = '05'
        }
        if (array[0] === 6) {
          array[0] = '06'
          array[1] = '07'
          array[2] = '08'
          array[3] = '09'
        }
        return array
      }
    },
    getSearchAreaName () {
      return this.searchAreaName
    },
    getSearchUnitName () {
      return this.searchUnitName
    },
    getSearchProductionBaseCode () {
      return this.searchProductionBaseCode
    },
    getListType () {
      return this.listType
    }
  },
  watch: {
    getSearchAreaName: function (newData, oldData) {
      if (this.areaData && 'areas' in this.areaData) {
        if (newData !== '') {
          this.searchUnitName = ''
          this.searchProductionBaseCode = ''
          this.searchFacilityName = ''
        }
        this.setUnits()
        this.setProductionBases()
        this.setFacilities()
      }
    },
    getSearchUnitName: function (newData, oldData) {
      if (this.unitData && 'units' in this.unitData) {
        if (newData !== '') {
          this.searchProductionBaseCode = ''
          this.searchFacilityName = ''
        }
        this.setProductionBases()
        this.setFacilities()
      }
    },
    getSearchProductionBaseCode: function (newData, oldData) {
      if (this.productionBaseData && 'productionBases' in this.productionBaseData) {
        if (newData !== '') {
          this.searchFacilityName = ''
        }
        this.setFacilities()
      }
    },
    getListType: function (newData, oldData) {
      this.setFacilities()
    }
  },
  created () {
    this.setCookieData()
    if (JSON.parse(localStorage.getItem('isPageBack'))) {
      this.pageBackDataSetUp()
    }
  },
  mounted: async function () {
    if (JSON.parse(localStorage.getItem('isPageBack'))) {
      await this.pageBackSetUp()
    } else {
      await this.setProjects(this.listType)
    }

    this.setAreas()
    this.setUnits()
    this.setProductionBases()
    this.setFacilities()
    this.getCheckBouquet()
    this.getCheckOutsideCommerce()
    this.getCheckHotelOthers()
    this.getCheckNotSalesOthers()
    this.setMaterialsAndEquipmentAdjustmentListURL()
    this.setDeliveryEvaluationURL()
  }
}
</script>
<style scoped>
table > thead > tr > th {
  background-color: #161C3D !important;
  border: 1px solid #dee2e6 !important;
  color: #fefefe;
  font-weight: normal;
}
.bb-none {
  border-bottom: none !important;
}
.bt-none {
  border-top: none !important;
}
/*.table-hover tbody tr.hover-no-color:hover {*/
/*  color: unset;*/
/*  background-color: unset;*/
/*}*/
/*a {*/
/*  color: #dee2e6;*/
/*}*/
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
table {
  border-collapse: separate;
  border-spacing: 0px;
}
thead {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
}
th, td {
  padding: 0px 10px !important;
}
.button-font-small {
  font-size: 83%;
  width: 100px;
}
.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}
.sort-check {
  width:20px;
  height:20px;
}
.button-adjustment {
  padding:6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProjectList.vue